import { getApiBaseUrl } from '@/utils/apiBase'
import defaultAvatar from '@/assets/logo.png'
import {
  getPortalForCurrentRoute,
  getPortalSession,
  PORTAL_PLATFORM,
  PORTAL_TENANT,
} from '@/utils/authSession'

export function getLoginUserFromSessionPayload(session) {
  if (!session) return {}
  if (session.users && typeof session.users === 'object') {
    return session.users
  }
  if (session.user?.users && typeof session.user.users === 'object') {
    return session.user.users
  }
  if (session.user && typeof session.user === 'object') {
    return session.user
  }
  return {}
}

/** 读取指定门户登录会话 */
export function getLoginSession(portal) {
  const resolvedPortal = portal || getPortalForCurrentRoute()
  return getPortalSession(resolvedPortal)?.session ?? null
}

/**
 * 当前登录用户对象（兼容 users / user.users 等历史结构）
 */
export function getLoginUser(portal) {
  return getLoginUserFromSessionPayload(getLoginSession(portal))
}

function pickLoginUser(user) {
  if (user && (user.realName || user.real_name || user.username || user.avatarUrl || user.avatar_url)) {
    return user
  }
  return getLoginUser()
}

export function getLoginUserDisplayName(user) {
  const u = pickLoginUser(user)
  return u.realName || u.real_name || u.username || ''
}

/**
 * 解析用户头像 URL；无头像时返回默认图
 */
export function resolveUserAvatarUrl(user) {
  const u = pickLoginUser(user)
  const raw = (u.avatarUrl || u.avatar_url || '').trim()
  if (!raw) {
    return defaultAvatar
  }
  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw
  }
  const base = getApiBaseUrl()
  if (!base) {
    return raw.startsWith('/') ? raw : `/${raw}`
  }
  const path = raw.startsWith('/') ? raw.slice(1) : raw
  return base + path
}

export { PORTAL_PLATFORM, PORTAL_TENANT }
